// extracted by mini-css-extract-plugin
module.exports = {"icon":"__icon__0_Hmg","accordion":"__accordion__p8LNf"};